var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.getLoader),expression:"getLoader"}],staticClass:"get-loader h-full bg-white w-full flex-center"},[_c('div',{staticClass:"loading w-8 h-8 rounded-full bg-main animate-ping"})])
}
var staticRenderFns = []

export { render, staticRenderFns }